import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import Highcharts from 'highcharts';
import _ from 'lodash';


import RetryableContent from "../../../../../components/RetryableContent";
import { CommonWidgetUtils, LanguageUtils, LoadStatus, ToastUtil } from '../../../../../utils';
import { fiinService, marketAnalysisService } from "../../../../../services";
import CommonUtils from './../../../../../utils/CommonUtils';

import './SalesReportChart.scss';

const TAB = {
    ISA20: 'ISA20',
    ISA1: 'ISA1',
    // ISA11: 'ISA11',
}


class SalesReportChart extends Component {
    initialState = {
        loadStatus: LoadStatus.NONE,
        valueMatchedSelected: 1,
        records: [],
        dataChart: {}
    };

    constructor(props) {
        super(props);
        this.state = {
            ...this.initialState
        }
    };

    _setState = (obj, callback) => {
        if (this.mounted) {
            this.setState(obj, callback);
        }
    }

    componentDidMount() {
        this.mounted = true
        this.loadData();
        this.getChart();
    }

    componentWillUnmount() {
        if (this.chart) this.chart.destroy()
        this.chart = undefined
        this._setState({
            ...this.initialState
        })
        this.mounted = false
    }

    onReset = () => {
        this._setState({ ...this.initialState })
    }


    loadData = async () => {
        const { currentSymbol, typeTime } = this.props;
        if (currentSymbol && currentSymbol.id) {
            let body = {
                symbol: currentSymbol ? currentSymbol.id : "",
                limit: 5,
                value: typeTime,
            };
            this._setState({ loadStatus: LoadStatus.LOADING })
            await fiinService.getIncomeStatement(body)
                .then((res) => {
                    if (res && res.length > 0) {
                        this._setState({ records: res })
                    } else {
                        this._setState({ records: [] })
                    }
                    this._setState({ loadStatus: LoadStatus.LOADED })
                })
                .catch((error) => {
                    this._setState({ loadStatus: LoadStatus.FAIL })
                    ToastUtil.errorApi(error)
                });
        }
    }


    getChart = () => {
        if (this.chart) return this.chart;
        const self = this
        const { language, defaultTheme } = this.props
        const labelStyle = {
            color: 'white',
            fontFamily: 'Helvetica Neue Regular',
            fontWeight: 400,
        };
        this.chart = new Highcharts.chart('id-chart-sales-report', {
            chart: {
                type: 'column',
                backgroundColor: null,
                plotBackgroundColor: null,
                plotBorderWidth: 0,
                plotShadow: false,
                zoomType: 'y',
                style: labelStyle,
                marginTop: 30, // Giảm khoảng cách trên
                marginBottom: 30, // Giảm khoảng cách dưới
                height: 300, // Chiều cao của đồ thị
            },
            title: {
                text: null,
            },
            xAxis: [{
                categories: [],
                crosshair: true,
                labels: {
                    style: labelStyle
                },
            }],
            yAxis: [
                { // Primary axis
                    className: 'highcharts-color-0',
                    title: {
                        // text: 'Weight'
                    },
                    visible: false // Hide the primary yAxis
                },
                { // Secondary axis
                    className: 'highcharts-color-1',
                    // opposite: true,
                    title: {
                        // text: 'BMI'
                    },
                    visible: false // Hide the secondary yAxis
                }
            ],
            tooltip: {
                crosshairs: true,
                animation: true,
                shared: true,
                useHTML: true,
                formatter: function () {
                    let value0 = this.points[0] ? `${CommonUtils.formatNumberWithCommas(this.points[0].y)} ${LanguageUtils.getMessageByKey(`market-watch.billion`, self.props.language)}` : "0"
                    let value1 = this.points[1] ? `${CommonUtils.formatNumberWithCommas(this.points[1].y)} ${LanguageUtils.getMessageByKey(`market-watch.billion`, self.props.language)}` : "0"

                    let seriesName0 = this.points[0] ? `${this.points[0].series.name}` : ""
                    let seriesName1 = this.points[1] ? `${this.points[1].series.name}` : ""

                    let label = `
                        <div>
                            <div class="tooltip-category-label">
                                ${this.x} 
                            </div>
                            <div>
                                ${LanguageUtils.getMessageByKey(`sales-report-chart.ISA20`, self.props.language)}: ${value0}
                            </div>
                            <div>
                                ${LanguageUtils.getMessageByKey(`sales-report-chart.ISA1`, self.props.language)}: ${value1}
                            </div>
                        </div>
                        `
                    return label
                },
            },
            legend: {
                enabled: false,
                // labelFormatter: function () {
                //     return `<div style="margin-top:-1px">${this.name} ${LanguageUtils.getMessageByKey("index-main-chart.unit-billion", self.props.language)}</div>`;
                // },
                // itemMarginBottom: 10,
                // itemDistance: 10,
                // floating: false,
                // margin: 0,
                // itemStyle: {
                //     color: 'white',
                //     fontWeight: "0",
                //     fontSize: 14
                // },
                // itemHoverStyle: {
                //     color: '#1A7ECB'
                // },
                // maxHeight: 150,
                // navigation: {
                //     activeColor: 'white',
                //     inactiveColor: 'gray',
                //     style: {
                //         color: 'white',
                //     }
                // },
                // shadow: false,
                // symbolHeight: 16,
                // symbolWidth: 16,
                // symbolRadius: 0,
                // useHTML: true,
                // align: 'left',
                // x: 0,
                // verticalAlign: 'top',
                // // y: -10,
                // floating: true,
            },
            plotOptions: {
                column: {
                    minPointLength: 5, // Điều chỉnh độ dài tối thiểu của cột
                    pointPadding: 0, // Điều chỉnh khoảng cách giữa các cột
                    groupPadding: 0.1, // Giảm khoảng cách giữa các nhóm cột (nếu có)
                    borderWidth: 0,
                    // pointWidth: 28, // Đặt độ rộng cố định cho các cột
                    color: '#265CAB',
                    dataLabels: {
                        enabled: true,
                        crop: false,
                        overflow: 'none',
                        allowOverlap: true, // Cho phép các nhãn dữ liệu chồng lên nhau
                        style: {
                            ...labelStyle,
                            textOutline: 'none',
                            fontSize: '9px',   // Kích thước chữ
                        },
                        verticalAlign: 'top',
                        y: -20,
                        inside: true,
                    },
                },
                series: {// Disable click event
                    events: {
                        legendItemClick: function () {
                            return false; // Disable click vào legend
                        }
                    }
                }
            },
            series: [
                {
                    name: LanguageUtils.getMessageByKey(`sales-report-chart.ISA20`, language),
                    data: [],
                    color: 'rgba(58, 79, 172, 1)',
                }, {
                    name: LanguageUtils.getMessageByKey(`sales-report-chart.ISA1`, language),
                    data: [],
                    color: 'rgba(242, 100, 212, 1)',
                },
            ]
        });
        return this.chart;
    };


    componentDidUpdate(prevProps, prevState) {
        const { records, } = this.state;
        const { records: prevRecords } = prevState;
        const { typeTime, currentSymbol } = this.props
        const { currentSymbol: prevCurrentSymbol } = prevProps;
        if (!(_.isEqual(currentSymbol, prevCurrentSymbol))) {
            if (currentSymbol && currentSymbol.id) {
                this.loadData();
            }
        }
        if (typeTime != prevProps.typeTime) {
            this.loadData();
        }
        if (!(_.isEqual(records, prevRecords))) {
            this.setDataChart();
        }
        if (this.props.language !== prevProps.language) {
            if (!this.chart) return;
            this.chart.series[0].setName(LanguageUtils.getMessageByKey(`sales-report-chart.ISA20`, this.props.language));
            this.chart.series[1].setName(LanguageUtils.getMessageByKey(`sales-report-chart.ISA1`, this.props.language));
            this.chart.redraw(false);
        }
    }

    setDataChart = () => {
        if (!this.chart) return;
        const { records, valueMatchedSelected } = this.state;
        const { typeTime, typeTab } = this.props
        let isa20 = [], isa1 = [], isa11 = [], categories = []
        records.forEach((item, index) => {
            let _isa20 = null, _isa1 = null, _isa11 = null
            if (item.isa20 && item.isa20 != "0" && item.isa20 != "0.00") {
                _isa20 = Math.round((Number(item.isa20) / 1000000000)) || null
            }
            if (item.isa1 && item.isa1 != "0" && item.isa1 != "0.00") {
                _isa1 = Math.round((Number(item.isa1) / 1000000000)) || null
            }
            if (item.isa11 && item.isa11 != "0" && item.isa11 != "0.00") {
                _isa11 = Math.round((Number(item.isa11) / 1000000000)) || null
            }
            isa20.unshift(_isa20)
            isa1.unshift(_isa1)
            isa11.unshift(_isa11)
            let itemCategory = ""
            if (typeTime == typeTab.QUARTER) {
                itemCategory = `<span class="category-label text-active">Q${parseInt(item.lengthreport, 10)}/${parseInt(item.yearreport, 10)}</span>`
            } else {
                itemCategory = `<span class="category-label text-active">${parseInt(item.yearreport, 10)}</span>`
            }
            categories.unshift(itemCategory)
        })
        this.chart.xAxis[0].setCategories(categories);
        this.chart.series[0].setData(isa20);
        this.chart.series[1].setData(isa1);
    }

    render() {
        const { records } = this.state

        // //console.log("binh_records", this.state)
        return (
            <RetryableContent className="company-financial-symbol-chart index-main-chart" status={this.state.loadStatus} disableRetry={true}>
                <div className="header-block-chart">
                    <div className="title txt---700-14-20">
                        <FormattedMessage id={`sales-report-chart.title`} />
                    </div>
                </div>
                <div className="body-block-chart">
                    <div className="index-main-chart-content">
                        <div class="action-container" style={{ minHeight: "30px", visibility: "hidden" }}>
                            <div class="list-select-exchange">

                            </div>
                        </div>
                        <div className="legend-container">
                            <div className='legend-item multi-column'>
                                <div className='block-legend-color block-legend-color-1'></div>
                                <div className='block-legend-text txt---400-12-20'>
                                    <FormattedMessage id={`sales-report-chart.ISA20`} /> <FormattedMessage id={`index-main-chart.unit-billion`} />
                                </div>
                            </div>
                            <div className='legend-item multi-column'>
                                <div className='block-legend-color block-legend-color-2'></div>
                                <div className='block-legend-text txt---400-12-20'>
                                    <FormattedMessage id={`sales-report-chart.ISA1`} /> <FormattedMessage id={`index-main-chart.unit-billion`} />
                                </div>
                            </div>
                        </div>
                        <div id="id-chart-sales-report"></div>
                    </div >
                </div >
            </RetryableContent >
        );
    }
}

const mapStateToProps = (state) => {
    let _currentLayoutPageActive = CommonWidgetUtils.getReplaceLayoutPageActive()
    let _layoutPage = state.layout.layoutPage[_currentLayoutPageActive]
    let _accountInfo = _layoutPage && _layoutPage["accountInfo"]
    const userInfo = state.user.userInfo;
    const defaultTheme = state.user.userInfo && state.user.userInfo.defaultTheme
    let _curSymbolTrade = (_layoutPage && _layoutPage["symbols"] && _layoutPage["symbols"]["curSymbolTrade"]) || {};
    return {
        currentSymbol: _curSymbolTrade,
        isDeskTop: state.app.isDeskTop,
        config: state.user.userInfo.config,
        userInfo: userInfo,
        language: state.app.language,
        defaultTheme,
    };
};

export default connect(mapStateToProps, null)(SalesReportChart);
